import type { ActionContext, ActionTree } from 'vuex';
import type { IVocabularyBuilderState } from '@/store/modules/vocabulary-builder/types';
import type { RootState } from '@/store/types';
import { getTrpcClient, trpcCall } from '@/trpc';

type VocabularyBuilderActionContext = ActionContext<IVocabularyBuilderState, RootState>;
type VocabularyBuilderActionTree = ActionTree<IVocabularyBuilderState, RootState>;

export const actions: VocabularyBuilderActionTree = {
  async fetchWords(context: VocabularyBuilderActionContext): Promise<any> {
    const words = await trpcCall(() => getTrpcClient().wordsmith.words.query());

    context.commit('setWords', words);
  },

  async setSort(
    _context: VocabularyBuilderActionContext,
    payload: { word_id: number; sort: 'yes' | 'no' | 'maybe' }
  ): Promise<any> {
    await trpcCall(() => getTrpcClient().wordsmith.sort.mutate(payload));
  },

  async fetchReview(context: VocabularyBuilderActionContext): Promise<any> {
    const { levels, sorts, term_count } = context.state.filter;
    const review = await trpcCall(() => getTrpcClient().wordsmith.review.query({ levels, sorts, limit: term_count }));

    context.commit('setReview', review);
  },

  async fetchTest(context: VocabularyBuilderActionContext): Promise<any> {
    const { levels, sorts, question_types, term_count } = context.state.filter;
    const test = await trpcCall(() =>
      getTrpcClient().wordsmith.startTest.mutate({ levels, sorts, types: question_types, limit: term_count })
    );

    context.commit('setTest', test);
  },

  async finishTest(context: VocabularyBuilderActionContext, payload: any): Promise<any> {
    const finish = await trpcCall(() =>
      getTrpcClient().wordsmith.finishTest.mutate({ id: payload.id, answers: payload.answers })
    );

    context.commit('setTestReview', finish);
  },

  async fetchCount(context: VocabularyBuilderActionContext): Promise<any> {
    const { levels, sorts } = context.state.filter;
    // an empty filter counts everything, as the REST endpoint did
    const count = await trpcCall(() =>
      getTrpcClient().wordsmith.count.query({
        levels: levels.length ? levels : undefined,
        sorts: sorts.length ? sorts : undefined,
      })
    );
    context.commit('setCount', count);
  },

  async fetchWordOfTheDay(context: VocabularyBuilderActionContext): Promise<any> {
    const word = await trpcCall(() => getTrpcClient().wordsmith.wordOfTheDay.query());
    context.commit('setWordOfTheDay', word);
  },
};
